export default {
    props: {
        value: {
            type: Object,
            default () {
              return {}
            }
        },
        api: {
            type: String,
            default: ''
        },
        exportApi: {
            type: String,
            default: ''
        },
        lazyLoadApi: {
            type: String,
            default: ''
        },
        items: {
            type: Array,
            default () {
              return []
            }
        },
        page: {
            type: Boolean,
            default: true
        },
        params: {
            type: [Object, Function],
            default () {
              return {}
            }
        },
        autoSearch: {
            type: Boolean,
            default: true
        },
        rowKey: {
            type: [String, Function],
            default: 'id'
        },
        disHover: { // 是否有Hover效果
            type: Boolean,
            default: false
        },
        lazyLoadParamNames: { // 懒加载参数标识 key为每行对象的key值，value为要传递给后端的参数名称
            type: [Object, Array],
            default () {
                return {}
            }
        },
        // 懒加载
        lazy: {
            type: Boolean,
            default: false
        },
        bordered: {
            type: Boolean,
            default: false
        },
        autoId: {
            type: Boolean,
            default: false
        },
        autoHeight: {
            type: Boolean,
            default: false
        },
        fixedHeight: { // 固定高度 优先级最高
            type: [Number,String]
        },
        pageSize: {
            type: Number,
            default: 25
        },
        pager: {
            type: Array,
            default () {
                return [10, 25, 50, 100]
            }
        },
        defaultLoading: { // 默认为加载状态
            type: Boolean,
            default: false
        },
        pageInfo: {
            type: Object,
            default () {
                return {}
            }
        },
        showButton: {
            type: Boolean,
            default: true
        },
        columns: {
            type: Array,
            default: () => []
        },
        enableToolbar: {
            type: Boolean,
            default: true
        }
    },
    methods: {
        onSortChange (sort, meta) {
            this.$emit('on-sort-change', sort, meta)
        },
        isReady () {
            return !!this.init
        },
        isEmpty () {
            if (!this.$refs.dataGrid) return
            return this.$refs.dataGrid.isEmpty()
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/framework/data-grid/data-grid-mixins.js